import { TCustomerField } from 'modules/checkout/domain/entities';

export default function getCustomerRegistrationMeta(
  missingFields: TCustomerField[],
) {
  return {
    shouldConfirmDocument:
      missingFields.includes('document') && missingFields.includes('birthdate'),
    isMinorityUncertain: missingFields.includes('birthdate'),
  };
}
